enum SidebarRightMode {
	NONE = "NONE",
	INFO = "INFO",
	SECURITY = "SECURITY",
	ANNOTATION = "ANNOTATION",
	HISTORY = "HISTORY"
}

export default SidebarRightMode;